import useCarouselLayout from "../../hooks/useCarouselLayout";
import React from "react";
import Slider from "react-slick";
import profilePhoto1 from "../../Assets/profile-photos/DebayanGhosh.jpeg";
import profilePhoto2 from "../../Assets/profile-photos/Dipdey.jpeg";
import profilePhoto3 from "../../Assets/profile-photos/srijitadas.jpeg";
import profilePhoto4 from "../../Assets/profile-photos/Snehadas.jpeg";
import profilePhoto5 from "../../Assets/profile-photos/pritidi.jpeg";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AOS from "aos";
import "aos/dist/aos.css";

// Sample profiles: replace with verified details and photo imports or URLs.
const interviewProfiles = [
  { id: 1, name: "Debayan Ghosh", photo: profilePhoto1, color: "#0369a1", background: "B.Tech in Computer Science",Course:"Tally Prime & Advance Excel", company: "Sample Tech Co.", role: "Accountant" },
  { id: 2, name: "Dip Dey", photo: profilePhoto2, color: "#047857", background: "B.Com with an interest in finance",Course:"Tally Prime & Advance Excel", company: "Sample Finance Co.", role: "Accountant" },
  { id: 3, name: "Srijita Das", photo: profilePhoto3, color: "#7c3aed", background: "Diploma in Mechanical Engineering",Course:"Frontend Development", company: "Star Info Lab", role: "Frontend Develop[er" },
  { id: 4, name: "Sneha Das", photo: profilePhoto4, color: "#be185d", background: "BBA in Marketing", company: "Sample Media Co.",Course:"Tally Prime & Advance Exce", role: "Office Executive" },
  { id: 5, name: "Priti Banik", photo: profilePhoto5, color: "#b45309", background: "B.Sc in Information Technology", Course:"Frontend Development",company: "Prillix Lab", role: "Frontend Developer" },
];

export default function SimpleSliderSection() {
  const { containerRef, slidesToShow } = useCarouselLayout(4, 900);

  React.useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
      disable: false,
    });
  }, []);

  function NextArrow(props) {
    const { onClick } = props;

    return (
      <div
        className="custom-arrow next"
        onClick={onClick}
      >
        ❯
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;

    return (
      <div
        className="custom-arrow prev"
        onClick={onClick}
      >
        ❮
      </div>
    );
  }

  // Responsive Slick settings:
  // Desktop: 4 cards | small desktop/tablet: 3 | tablet: 2 | mobile: 1
  const settings = {
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    pauseOnFocus: true,
    dots: false,
    infinite: interviewProfiles.length > 1,
    speed: 500,
    arrows: true,
    slidesToShow,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchMove: true,
    draggable: true,
    variableWidth: false,
    centerMode: false,
    adaptiveHeight: false,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,


  };

  return (
    <>
      <style>{`
      @media (max-width: 1024px) {

          .slider-section {
            padding: 60px 0;
          }

          .slider-container {
            padding: 0 30px;
          }

          .section4-title {
            font-size: 26px;
          }

          .section4-profiles .prev {
            left: -12px;
          }

          .section4-profiles .next {
            right: -12px;
          }
        }

        /* =========================================
           SLIDER ARROWS
        ========================================= */

        .section4-profiles .custom-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);

          width: 44px;
          height: 44px;

          background: rgba(255, 255, 255, 0.96);

          border: 1px solid rgba(14, 165, 233, 0.12);

          border-radius: 50%;

          display: flex !important;
          align-items: center;
          justify-content: center;

          font-size: 18px;
          font-weight: 600;

          color: #334155;

          cursor: pointer;

          z-index: 10;

          box-shadow:
            0 5px 15px rgba(15, 23, 42, 0.10);

          transition:
            transform 0.35s ease,
            background 0.35s ease,
            color 0.35s ease,
            box-shadow 0.35s ease,
            border-color 0.35s ease;
        }


        .section4-profiles .custom-arrow:hover {
          background: #0ea5e9;

          color: #ffffff;

          border-color: #0ea5e9;

          box-shadow:
            0 10px 25px rgba(14, 165, 233, 0.28);

          transform:
            translateY(-50%)
            scale(1.08);
        }


        .section4-profiles .custom-arrow:active {
          transform:
            translateY(-50%)
            scale(0.96);
        }


        /* LEFT ARROW */

        .section4-profiles .prev {
          left: -22px;
        }


        /* RIGHT ARROW */

        .section4-profiles .next {
          right: -22px;
        }



        /* =========================================
           MAIN SECTION
        ========================================= */

        .slider-section {
          width: 100%;

          padding: 70px 0;

          background:
            linear-gradient(
              180deg,
              #f8fafc 0%,
              #ffffff 100%
            );

          overflow: hidden;
        }



        /* =========================================
           SLIDER CONTAINER
        ========================================= */

        .slider-container {
          max-width: 1100px;

          margin: auto;

          padding: 0 20px;

          position: relative;
        }



        /* =========================================
           HEADING
        ========================================= */

        .section4-title {
          font-size: 28px;

          font-weight: 600;

          color: #1e293b;

          margin-bottom: 32px;

          text-align: left;

          line-height: 1.3;

          letter-spacing: -0.3px;

          position: relative;
        }


        .section4-title::after {
          content: "";

          display: block;

          width: 55px;

          height: 3px;

          margin-top: 12px;

          border-radius: 10px;

          background:
            linear-gradient(
              90deg,
              #0ea5e9,
              #22c55e
            );
        }



        /* =========================================
           SLIDE CARD
        ========================================= */

        .slide-card {
          height: 120px;

          background:
            linear-gradient(
              135deg,
              #dbeafe,
              #d1d5db
            );

          border-radius: 10px;

          margin: 0 10px;

          border: 1px solid rgba(148, 163, 184, 0.20);

          position: relative;

          overflow: hidden;

          cursor: pointer;

          transition:
            transform 0.4s ease,
            box-shadow 0.4s ease,
            background 0.4s ease,
            border-color 0.4s ease;
        }


        /* SHINE EFFECT */

        .slide-card::before {
          content: "";

          position: absolute;

          top: 0;
          left: -120%;

          width: 80%;
          height: 100%;

          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.35),
              transparent
            );

          transform: skewX(-20deg);

          transition: left 0.7s ease;
        }


        .slide-card:hover::before {
          left: 140%;
        }


        /* CARD HOVER */

        .slide-card:hover {
          background:
            linear-gradient(
              135deg,
              #bfdbfe,
              #bbf7d0
            );

          transform:
            translateY(-7px);

          border-color:
            rgba(14, 165, 233, 0.25);

          box-shadow:
            0 12px 28px
            rgba(15, 23, 42, 0.13);
        }



        /* =========================================
           SLICK SPACING
        ========================================= */

        .section4-profiles .slick-slide {
          padding: 0 5px;

          box-sizing: border-box;
        }


        .section4-profiles .slick-list {
          margin: 0 -5px;

          padding-top: 8px;
          padding-bottom: 12px;
        }


        .section4-profiles .slick-track {
          display: flex;

          align-items: center;
        }



        /* =========================================
           REMOVE DEFAULT SLICK ARROW STYLE
        ========================================= */

        .section4-profiles .slick-prev,
        .section4-profiles .slick-next {
          width: auto;
          height: auto;
        }


        .section4-profiles .slick-prev::before,
        .section4-profiles .slick-next::before {
          display: none;
        }



        /* =========================================
           TABLET
        ========================================= */

        @media (max-width: 1024px) {

          .slider-section {
            padding: 60px 0;
          }

          .slider-container {
            padding: 0 30px;
          }

          .section4-title {
            font-size: 26px;
          }

          .section4-profiles .prev {
            left: -12px;
          }

          .section4-profiles .next {
            right: -12px;
          }
        }



        /* =========================================
           MOBILE
        ========================================= */

        @media (max-width: 768px) {

          .slider-section {
            padding: 55px 0;
          }

          .slider-container {
            padding: 0 24px;
          }

          .section4-title {
            font-size: 24px;

            margin-bottom: 28px;
          }

          .slide-card {
            height: 115px;

            margin: 0 7px;
          }

          .section4-profiles .slick-slide {
            padding: 0 3px;
          }

          .section4-profiles .slick-list {
            margin: 0 -3px;
          }

          .section4-profiles .prev {
            left: -10px;
          }

          .section4-profiles .next {
            right: -10px;
          }

          .section4-profiles .custom-arrow {
            width: 40px;
            height: 40px;

            font-size: 16px;
          }
        }



        /* =========================================
           SMALL MOBILE
        ========================================= */

        @media (max-width: 480px) {

          .slider-section {
            padding: 45px 0;
          }

          .slider-container {
            padding: 0 20px;
          }

          .section4-title {
            font-size: 21px;

            line-height: 1.4;
          }

          .slide-card {
            height: 110px;
          }

          .section4-profiles .custom-arrow {
            width: 36px;
            height: 36px;

            font-size: 14px;
          }

          .section4-profiles .prev {
            left: -8px;
          }

          .section4-profiles .next {
            right: -8px;
          }
        }


        .section4-profiles .section4-title { margin-bottom: 12px; }
        .section4-sample-note { color: #64748b; font-size: 13px; margin-bottom: 28px; }
        .section4-profiles .slick-track { align-items: stretch; }
        .section4-profiles .slick-slide { height: auto; }
        .section4-profiles .slick-slide > div,
        .section4-profiles .slick-slide > div > div { height: 100%; }
        .section4-profiles .section4-profile-card {
          height: 100%;
          min-height: 365px;
          background: white;
          border-radius: 16px;
          cursor: default;
          font-family: "Poppins", sans-serif;
        }
        .section4-profiles .section4-profile-card::before { display: none; }
        .section4-profile-top {
          padding: 24px 16px 18px;
          text-align: center;
          background: linear-gradient(135deg, #e0f2fe, #ecfdf5);
          border-bottom: 1px solid #e2e8f0;
        }
        .section4-avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 70px;
          height: 70px;
          margin: 0 auto 12px;
          border: 3px solid white;
          border-radius: 50%;
          overflow: hidden;
          background: var(--profile-color);
          color: white;
          font-size: 24px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
        }
        .section4-avatar img { width: 100%; height: 100%; object-fit: cover; object-position: center; }
        .section4-profile-top h3 { font-size: 18px; line-height: 1.4; color: #1e293b; }
        .section4-profile-body { padding: 18px; }
        .section4-profile-body h4 {
          margin: 0 0 6px;
          color: #475569;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
        .section4-background {
          min-height: 44px;
          margin: 0 0 18px;
          color: #334155;
          font-size: 13px;
          line-height: 1.7;
        }
        .section4-interview {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 5px;
          font-size: 12px;
          line-height: 1.6;
          color: #64748b;
          overflow-wrap: anywhere;
        }
        .section4-interview strong { color: #1e293b; font-size: 13px; }
        .section4-interview-status {
          padding: 3px 9px;
          margin-bottom: 3px;
          border-radius: 20px;
          background: #dcfce7;
          color: #166534;
          font-size: 10px;
          font-weight: 600;
        }
          /* =====================================================
   RESPONSIVE PROFILE CARDS
   Mobile | iPhone | iPad | MacBook | Desktop | 4K
===================================================== */

/* Global box sizing */
.section4-profiles,
.section4-profiles *,
.section4-profiles *::before,
.section4-profiles *::after {
    box-sizing: border-box;
}

/* Main section */
.section4-profiles {
    width: 100%;
    max-width: 100%;
    padding: clamp(30px, 5vw, 70px) 0;
    overflow: hidden;
}

/* Main container */
.section4-profiles .slider-container {
    width: 100%;
    max-width: 1400px;
    margin-inline: auto;
    padding-inline: clamp(12px, 3vw, 40px);
    min-width: 0;
}

/* Section heading */
.section4-profiles .section4-title {
    font-size: clamp(21px, 2vw, 32px);
    line-height: 1.35;
    margin-bottom: 14px;
    overflow-wrap: anywhere;
}

/* Description below heading */
.section4-profiles .section4-sample-note {
    max-width: 100%;
    font-size: clamp(12px, 1vw, 14px);
    line-height: 1.7;
    margin-bottom: clamp(18px, 3vw, 28px);
    overflow-wrap: anywhere;
}

/* Slick slider */
.section4-profiles .slick-slider {
    width: 100%;
    min-width: 0;
}

/* Slider viewport */
.section4-profiles .slick-list {
    width: 100%;
    min-width: 0;
    margin: 0;
    padding-top: 8px;
    padding-bottom: 15px;
    overflow: hidden;
}

/* Slider track */
.section4-profiles .slick-track {
    display: flex;
    align-items: stretch;
}

/* Individual slide */
.section4-profiles .slick-slide {
    height: auto;
    min-width: 0;
    padding: 0 8px;
    box-sizing: border-box;
}

/* Slide inner wrapper */
.section4-profiles .slick-slide > div {
    display: flex;
    width: 100%;
    height: 100%;
    min-width: 0;
}

/* Profile card */
.section4-profiles .section4-profile-card {
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    height: 100%;

    margin: 0;

    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;

    box-shadow: 0 5px 20px rgba(15, 23, 42, 0.07);

    overflow-wrap: anywhere;
    word-break: normal;
}

/* Profile card top section */
.section4-profiles .section4-profile-top {
    width: 100%;
    min-width: 0;

    padding: clamp(16px, 2vw, 24px)
             clamp(10px, 2vw, 18px);

    text-align: center;
}

/* Profile image */
.section4-profiles .section4-avatar {
    width: clamp(58px, 6vw, 76px);
    height: clamp(58px, 6vw, 76px);

    flex-shrink: 0;

    margin: 0 auto 12px;
    overflow: hidden;
    border-radius: 50%;
}

/* Profile image itself */
.section4-profiles .section4-avatar img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;

    object-fit: cover;
    object-position: center;
}

/* Profile name */
.section4-profiles .section4-profile-top h3 {
    max-width: 100%;
    margin: 0;

    font-size: clamp(15px, 1.4vw, 19px);
    line-height: 1.45;
    font-weight: 600;

    overflow-wrap: anywhere;
}

/* Profile card content */
.section4-profiles .section4-profile-body {
    display: flex;
    flex-direction: column;

    flex: 1;
    width: 100%;
    min-width: 0;

    padding: clamp(12px, 2vw, 20px);
}

/* Profile content headings */
.section4-profiles .section4-profile-body h4 {
    font-size: clamp(10px, 1vw, 12px);
    line-height: 1.5;
    letter-spacing: 0.5px;

    overflow-wrap: anywhere;
}

/* Profile background information */
.section4-profiles .section4-background {
    min-height: 0;
    max-width: 100%;

    font-size: clamp(12px, 1vw, 14px);
    line-height: 1.7;

    overflow-wrap: anywhere;
}

/* Interview information */
.section4-profiles .section4-interview {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    min-width: 0;

    gap: 6px;

    font-size: clamp(11px, 1vw, 13px);
    line-height: 1.7;

    overflow-wrap: anywhere;
    word-break: normal;
}

/* Interview details */
.section4-profiles .section4-interview strong {
    max-width: 100%;
    font-size: clamp(12px, 1vw, 14px);

    overflow-wrap: anywhere;
}

/* Status label */
.section4-profiles .section4-interview-status {
    display: inline-block;

    max-width: 100%;
    padding: 4px 9px;

    font-size: 10px;
    line-height: 1.5;

    white-space: normal;
    overflow-wrap: anywhere;
}

/* Slider arrows */
.section4-profiles .custom-arrow {
    width: 40px;
    height: 40px;

    display: flex !important;
    align-items: center;
    justify-content: center;

    z-index: 5;
}

/* =====================================================
   LARGE DESKTOPS AND MACBOOK DISPLAYS
===================================================== */

@media (min-width: 1440px) {

    .section4-profiles .slider-container {
        max-width: 1500px;
        padding-inline: 40px;
    }

    .section4-profiles .slick-slide {
        padding-inline: 10px;
    }

    .section4-profiles .section4-profile-card {
        border-radius: 18px;
    }

    .section4-profiles .section4-profile-body {
        padding: 22px;
    }
}

/* =====================================================
   TABLETS AND SMALL LAPTOPS
===================================================== */

@media (max-width: 1024px) {

    .section4-profiles .slider-container {
        padding-inline: 24px;
    }

    .section4-profiles .slick-slide {
        padding-inline: 6px;
    }

    .section4-profiles .section4-profile-top {
        padding: 20px 12px 16px;
    }

    .section4-profiles .section4-profile-body {
        padding: 15px;
    }

    .section4-profiles .prev {
        left: -8px;
    }

    .section4-profiles .next {
        right: -8px;
    }
}

/* =====================================================
   IPAD PORTRAIT AND MOBILE
===================================================== */

@media (max-width: 768px) {

    .section4-profiles {
        padding-block: 38px;
    }

    .section4-profiles .slider-container {
        padding-inline: 18px;
    }

    .section4-profiles .section4-title {
        margin-bottom: 12px;
        line-height: 1.4;
    }

    .section4-profiles .section4-sample-note {
        margin-bottom: 20px;
    }

    .section4-profiles .slick-slide {
        padding-inline: 5px;
    }

    .section4-profiles .section4-profile-card {
        border-radius: 14px;
    }

    .section4-profiles .section4-profile-top {
        padding: 18px 12px;
    }

    .section4-profiles .section4-profile-body {
        padding: 14px;
    }

    .section4-profiles .custom-arrow {
        width: 34px;
        height: 34px;
        font-size: 14px;
    }
}

/* =====================================================
   SMALL IPHONES AND 320px SCREENS
===================================================== */

@media (max-width: 480px) {

    .section4-profiles {
        padding-block: 28px;
    }

    .section4-profiles .slider-container {
        padding-inline: 12px;
    }

    .section4-profiles .section4-title {
        font-size: 21px;
        line-height: 1.4;
        margin-bottom: 10px;
        letter-spacing: -0.2px;
    }

    .section4-profiles .section4-sample-note {
        font-size: 12px;
        line-height: 1.65;
        margin-bottom: 16px;
    }

    .section4-profiles .slick-list {
        margin: 0;
        padding-top: 6px;
        padding-bottom: 12px;
    }

    .section4-profiles .slick-slide {
        padding-inline: 4px;
    }

    .section4-profiles .section4-profile-card {
        width: 100%;
        min-width: 0;
        border-radius: 12px;
    }

    .section4-profiles .section4-profile-top {
        padding: 16px 10px 14px;
    }

    .section4-profiles .section4-avatar {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
    }

    .section4-profiles .section4-profile-top h3 {
        font-size: 15px;
        line-height: 1.45;
    }

    .section4-profiles .section4-profile-body {
        padding: 12px;
    }

    .section4-profiles .section4-profile-body h4 {
        font-size: 10px;
        letter-spacing: 0.4px;
        margin-bottom: 5px;
    }

    .section4-profiles .section4-background {
        font-size: 12px;
        line-height: 1.65;
        margin-bottom: 14px;
    }

    .section4-profiles .section4-interview {
        font-size: 11px;
        line-height: 1.65;
        gap: 5px;
    }

    .section4-profiles .section4-interview strong {
        font-size: 12px;
    }

    .section4-profiles .section4-interview-status {
        font-size: 9px;
        padding: 4px 8px;
    }

    .section4-profiles .custom-arrow {
        width: 30px;
        height: 30px;
        font-size: 12px;
    }

    .section4-profiles .prev {
        left: -5px;
    }

    .section4-profiles .next {
        right: -5px;
    }
}

/* =====================================================
   EXTRA SMALL DEVICES: 280px–360px
===================================================== */

@media (max-width: 360px) {

    .section4-profiles .slider-container {
        padding-inline: 8px;
    }

    .section4-profiles .section4-title {
        font-size: 19px;
        line-height: 1.4;
    }

    .section4-profiles .section4-sample-note {
        font-size: 11px;
    }

    .section4-profiles .slick-slide {
        padding-inline: 3px;
    }

    .section4-profiles .section4-profile-top {
        padding: 14px 8px 12px;
    }

    .section4-profiles .section4-avatar {
        width: 54px;
        height: 54px;
    }

    .section4-profiles .section4-profile-top h3 {
        font-size: 14px;
    }

    .section4-profiles .section4-profile-body {
        padding: 10px;
    }

    .section4-profiles .section4-background {
        font-size: 11px;
        line-height: 1.6;
    }

    .section4-profiles .section4-interview {
        font-size: 10px;
        line-height: 1.6;
    }

    .section4-profiles .section4-interview strong {
        font-size: 11px;
    }

    .section4-profiles .custom-arrow {
        width: 27px;
        height: 27px;
        font-size: 11px;
    }

    .section4-profiles .prev {
        left: -4px;
    }

    .section4-profiles .next {
        right: -4px;
    }
}

/* =====================================================
   VERY NARROW DEVICES: 280px AND BELOW
===================================================== */

@media (max-width: 280px) {

    .section4-profiles .slider-container {
        padding-inline: 6px;
    }

    .section4-profiles .section4-title {
        font-size: 17px;
    }

    .section4-profiles .section4-profile-top {
        padding-inline: 6px;
    }

    .section4-profiles .section4-profile-body {
        padding: 9px;
    }

    .section4-profiles .section4-profile-top h3 {
        font-size: 13px;
    }

    .section4-profiles .section4-background {
        font-size: 10px;
    }

    .section4-profiles .custom-arrow {
        width: 24px;
        height: 24px;
    }
}

/* =====================================================
   IPHONE SAFARI AND TOUCH DEVICES
===================================================== */

@supports (-webkit-touch-callout: none) {

    .section4-profiles {
        width: 100%;
        max-width: 100%;
    }

    .section4-profiles .section4-profile-card {
        -webkit-transform: translateZ(0);
        -webkit-backface-visibility: hidden;
    }

    .section4-profiles .section4-profile-body,
    .section4-profiles .section4-profile-top {
        min-width: 0;
    }
}

/* Avoid hover-only effects on touchscreens */
@media (hover: none) {

    .section4-profiles .section4-profile-card:hover {
        transform: none;
    }

    .section4-profiles .section4-profile-card::before {
        display: none;
    }
}

/* Responsive arrow touch targets */
.section4-profiles .custom-arrow {
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

@media (max-width: 480px) {
    .section4-profiles .slider-container {
        padding-left: 16px;
        padding-right: 16px;
    }

    .section4-profiles .custom-arrow {
        width: 32px;
        height: 32px;
        font-size: 13px;
    }

    .section4-profiles .prev {
        left: -9px;
    }

    .section4-profiles .next {
        right: -9px;
    }
}

@media (max-width: 360px) {
    .section4-profiles .slider-container {
        padding-left: 12px;
        padding-right: 12px;
    }

    .section4-profiles .custom-arrow {
        width: 28px;
        height: 28px;
        font-size: 11px;
    }

    .section4-profiles .prev {
        left: -7px;
    }

    .section4-profiles .next {
        right: -7px;
    }
}

/* Respect reduced-motion accessibility settings */
@media (prefers-reduced-motion: reduce) {
    .section4-profiles .section4-profile-card,
    .section4-profiles .custom-arrow {
        transition: none !important;
    }
}
    /* Center the heading and description */
.section4-profiles .section4-title {
    width: 100%;
    text-align: center;
    margin: 0 auto 12px;
}

/* Keep the gradient underline centered */
.section4-profiles .section4-title::after {
    margin: 12px auto 0;
}

.section4-profiles .section4-sample-note {
    width: 100%;
    text-align: center;
    margin: 0 auto 28px;
}

/* Maintain alignment on mobile */
@media (max-width: 480px) {
    .section4-profiles .section4-title {
        font-size: 22px;
        text-align: center;
    }

    .section4-profiles .section4-sample-note {
        text-align: center;
        font-size: 12px;
        margin-bottom: 20px;
    }
}
    


      /* =========================================
         ANIMATED, SMOOTH WAVE BACKGROUND
      ========================================= */

      .section4-profiles {
        position: relative;
        isolation: isolate;
        overflow: hidden;
        background: linear-gradient(
          120deg,
          #b8f5f0 0%,
          #d9fce8 45%,
          #faffed 100%
        );
        background-size: 200% 200%;
        animation: profileGradientMove 12s ease-in-out infinite;
      }

      /* Keep heading, cards and controls above the waves */
      .section4-profiles .slider-container {
        position: relative;
        z-index: 2;
      }

      .section4-profiles .slick-slider {
        position: relative;
        z-index: 2;
      }

      /* Keep both arrows vertically centered beside the visible card */
      .section4-profiles .custom-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
      }

      .section4-profiles .custom-arrow.prev {
        left: -18px;
        right: auto;
      }

      .section4-profiles .custom-arrow.next {
        right: -18px;
        left: auto;
      }

      .section4-wave {
        position: absolute;
        left: -25%;
        bottom: -22%;
        width: 150%;
        height: 65%;
        border-radius: 50% 50% 0 0 / 18% 28% 0 0;
        pointer-events: none;
        z-index: 0;
        will-change: transform;
        transform-origin: center center;
      }

      .section4-wave--one {
        bottom: -24%;
        height: 65%;
        background: linear-gradient(
          160deg,
          rgba(116, 245, 213, 0.22),
          rgba(35, 224, 199, 0.58),
          rgba(0, 190, 225, 0.68)
        );
        animation: profileWaveOne 8s ease-in-out infinite alternate;
      }

      .section4-wave--two {
        bottom: -28%;
        height: 52%;
        background: linear-gradient(
          160deg,
          rgba(151, 255, 219, 0.35),
          rgba(0, 220, 203, 0.62),
          rgba(0, 180, 230, 0.72)
        );
        animation: profileWaveTwo 11s ease-in-out infinite alternate;
      }

      .section4-wave--three {
        bottom: -30%;
        height: 40%;
        background: linear-gradient(
          150deg,
          rgba(68, 239, 202, 0.35),
          rgba(0, 192, 216, 0.62),
          rgba(0, 160, 230, 0.72)
        );
        animation: profileWaveThree 9s ease-in-out infinite alternate;
      }

      @keyframes profileGradientMove {
        0%, 100% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
      }

      @keyframes profileWaveOne {
        0% { transform: translate3d(-3%, 0, 0) rotate(-2deg); }
        50% { transform: translate3d(1%, -7%, 0) rotate(1deg); }
        100% { transform: translate3d(4%, -2%, 0) rotate(3deg); }
      }

      @keyframes profileWaveTwo {
        0% { transform: translate3d(3%, 2%, 0) rotate(2deg); }
        50% { transform: translate3d(-3%, -9%, 0) rotate(-2deg); }
        100% { transform: translate3d(-5%, -3%, 0) rotate(1deg); }
      }

      @keyframes profileWaveThree {
        0% { transform: translate3d(-4%, 3%, 0) rotate(-1deg); }
        50% { transform: translate3d(3%, -8%, 0) rotate(2deg); }
        100% { transform: translate3d(5%, -1%, 0) rotate(-2deg); }
      }

      @media (max-width: 768px) {
        .section4-wave {
          left: -40%;
          width: 180%;
        }

        .section4-wave--one { height: 48%; }
        .section4-wave--two { height: 38%; }
        .section4-wave--three { height: 30%; }
      }

      @media (max-width: 360px) {
        .section4-wave {
          left: -50%;
          width: 200%;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .section4-profiles,
        .section4-wave {
          animation: none !important;
        }
      }


      /* Center profile-card body content consistently */
      .section4-profiles .section4-profile-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .section4-profiles .section4-profile-body > h4 {
        width: 100%;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
      }

      .section4-profiles .section4-background {
        width: 100%;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
      }

      .section4-profiles .section4-interview {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .section4-profiles .section4-interview-status {
        align-self: center;
      }

      .section4-profiles .section4-interview strong,
      .section4-profiles .section4-interview > span:not(.section4-interview-status) {
        width: 100%;
        text-align: center;
      }

      @media (max-width: 480px) {
        .section4-profiles .section4-profile-body {
          align-items: center;
          text-align: center;
        }

        .section4-profiles .section4-background,
        .section4-profiles .section4-interview,
        .section4-profiles .section4-profile-body > h4 {
          text-align: center;
        }
      }


      /* Final arrow positioning: centered vertically at each side of the card */
      .section4-profiles .slick-slider {
        position: relative;
      }

      .section4-profiles .custom-arrow {
        position: absolute !important;
        top: 50% !important;
        bottom: auto !important;
        transform: translateY(-50%) !important;
        z-index: 20 !important;
      }

      .section4-profiles .custom-arrow.prev {
        left: -18px !important;
        right: auto !important;
      }

      .section4-profiles .custom-arrow.next {
        right: -18px !important;
        left: auto !important;
      }

      @media (max-width: 480px) {
        .section4-profiles .custom-arrow {
          width: 34px;
          height: 34px;
        }

        .section4-profiles .custom-arrow.prev {
          left: -10px !important;
        }

        .section4-profiles .custom-arrow.next {
          right: -10px !important;
        }
      }

      @media (max-width: 360px) {
        .section4-profiles .custom-arrow {
          width: 30px;
          height: 30px;
        }

        .section4-profiles .custom-arrow.prev {
          left: -8px !important;
        }

        .section4-profiles .custom-arrow.next {
          right: -8px !important;
        }
      }

      `}


      </style>


      <section
        className="slider-section section4-profiles"
        data-aos="fade-up"
        data-aos-duration="700"
      >
        <div className="section4-wave section4-wave--one" aria-hidden="true"></div>
        <div className="section4-wave section4-wave--two" aria-hidden="true"></div>
        <div className="section4-wave section4-wave--three" aria-hidden="true"></div>

        <div className="slider-container" ref={containerRef}>

          {/* HEADING */}

          <h2
            className="section4-title"
            data-aos="fade-right"
            data-aos-duration="650"
            data-aos-delay="100"
          >
            Recently Cracked Interviews
          </h2>


          <p className="section4-sample-note">Sample profiles and interview results</p>

          {/* SLIDER */}

          <div
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="180"
          >

            <Slider {...settings}>
              {interviewProfiles.map((profile) => (
                <div key={profile.id}>
                  <article className="slide-card section4-profile-card">
                    <div className="section4-profile-top" style={{ "--profile-color": profile.color }}>
                      <div className="section4-avatar">
                        <img src={profile.photo} alt="Sample profile portrait" />
                      </div>
                      <h3>{profile.name}</h3>
                    </div>
                    <div className="section4-profile-body">
                      <h4>Background</h4>
                      <p className="section4-background">{profile.background}</p>
                      <h4>Recently cleared</h4>
                      <div className="section4-interview">
                        <span className="section4-interview-status">Interview cleared</span>
                        <strong>{profile.company}</strong>
                        <span>{profile.role}</span>
                      </div>
                    </div>
                  </article>
                </div>
              ))}
            </Slider>

          </div>

        </div>

      </section>
    </>
  );
}
